"use strict";

exports.__esModule = true;
exports.getSupportedWidgetProperties = getSupportedWidgetProperties;
/**
 * Get the supported properties for the given widget
 */
function getSupportedWidgetProperties(widget) {
  return widget.optionalProps.concat(widget.requiresProps);
}